import styles from './Loader.module.css';

export const Loader = () => (
  <div>
    <div className={styles.ldsEllipsis}>
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);
